<template>
  <div class="mb-16">
    <QuestionLabel :text="question.text" class="mt-1"></QuestionLabel>
    <table class="pb-6">
      <thead>
        <th class="pl-0 pb-4"></th>
        <th
          class="vertical-align-bottom text-right text-capitalize text-no-wrap"
        >
          Agree Percentage
        </th>
      </thead>

      <template v-if="data[0].groupedBy.length > 0">
        <tr v-for="(agg, i) in data" :key="agg.groupedBy[0].value">
          <td class="w-100 pl-10">{{ agg.groupedBy[0].text }}</td>
          <td class="text-right text-no-wrap">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <div v-bind="attrs" v-on="on">
                  <comparison-button
                    class="my-1"
                    :value="getRate(question.key, i)"
                  ></comparison-button>
                </div>
              </template>
              <span>{{ agg.groupedBy[0].text }}</span>
            </v-tooltip>
          </td>
        </tr>
      </template>
      <tr v-else>
        <td class="w-100 pl-10">All Responses</td>
        <td class="text-right text-no-wrap">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <div v-bind="attrs" v-on="on">
                <comparison-button
                  class="my-1"
                  :value="getRate(question.key, 0)"
                ></comparison-button>
              </div>
            </template>
            <span>All Responses</span>
          </v-tooltip>
        </td>
      </tr>
    </table>
  </div>
</template>

<style scoped lang="scss">
$blueFill: rgba(101, 146, 230, 0.15);
$greyFill: rgba(0, 0, 0, 0.05);

table {
  border-collapse: collapse; /* Remove cell spacing */

  thead {
    th {
      vertical-align: bottom;
      text-align: center;
      padding-top: 0.5rem;
      border-radius: 0.5rem 0.5rem 0 0;
      padding: 0.5rem 1rem 0.25rem 1rem;

      &:nth-child(even) {
        background: $greyFill;
      }
    }
  }

  th,
  td {
    padding: 0.25rem 1rem;
    border-bottom: 1px solid rgba(0, 0, 0, 0);
    text-align: left;
  }

  tr,
  tfoot {
    &:nth-child(odd) {
      th,
      td {
        &:nth-child(even) {
          background: $greyFill;
        }
      }
    }
    &:nth-child(even) {
      th,
      td {
        &:nth-child(even) {
          background: $greyFill;
        }
      }
    }
  }

  tr {
    &:hover {
      background: rgba(0, 0, 0, 0.15) !important;

      td {
        border-color: rgba(0, 0, 0, 0.25);
      }
    }

    &:nth-child(even) {
      background: $blueFill;
    }
  }

  tfoot {
    td {
      border-radius: 0 0 0.5rem 0.5rem;
      padding: 0.5rem;
    }
  }
}
</style>

<script>
import numeral from "numeral";

import ComparisonButton from "./QuestionReport.AgreeAnalysis.ComparisonButton.vue";
import QuestionLabel from "./QuestionReport.Label.vue";

export default {
  components: { QuestionLabel, ComparisonButton },
  filters: {
    percentage(val) {
      return numeral(val).format("0.00%");
    },
  },
  data: () => ({}),
  props: {
    survey: Object,
    question: Object,
    data: Array,
    dense: Boolean,
  },
  methods: {
    questionData(questionKey, aggIndex) {
      var results = this.data[aggIndex].results.filter(
        (x) => x.key === questionKey
      );
      if (results.length == 0) return null;
      else return results[0];
    },
    getRate(questionKey, aggIndex) {
      let data = this.questionData(questionKey, aggIndex);
      if (!data) return 0;

      var numerator = data.counts.reduce((val, count) => {
        let option = this.question.options.find((x) => x.value == count.key);
        if (option && option.weight > 0) {
          val += count.value;
        }

        return val;
      }, 0);

      var denominator = data.responses;

      if (!numerator) return 0;
      else return numerator / denominator;
    },
  },
};
</script>
